<template>
    <!-- 流行 -->
    <div class="Prevalent_box">
        <div class="juzhong-box">
            <div class="items-center">
                <div class="TouXiang-img"><img :src="ZhuTidata.image" alt=""></div>
                <div class="right-xinxi-text">
                    <p class="p-tlite-songName">{{ZhuTidata.name}}</p>
                    <p class="p-introduce-Name">{{ZhuTidata.content}}</p>
                    <div class="bk-tt">
                        <p class="p-pyle" @click="QuanSongPlay()">
                           <img src="../../assets/imgbofang.png" alt="">
                           播放全部
                        </p>
                        <!-- <div class="jiahao">+</div> -->
                    </div>
                </div>
            </div>
            <div class="liebiao">
                <p class="tlite-show">{{ $t('Navigation.liuxing') }} TOP {{list.length}}</p>
                <div class="fu-tilte">
                    <!-- <p class="songcover"></p> -->
                    <p class="songTlite" style="width: 640px;margin-left: 9px;"><span>{{ $t('songList.songTilte') }}</span></p>
                    <p class="songName"><span>{{ $t('songList.geshou') }}</span></p>
                    <p class="songzhuanji">{{ $t('songList.zhuanji') }}</p>
                    <p class="songTime">{{ $t('songList.shichang') }}</p>
                </div>
                <div class="song-dan" v-for="(item,index) in list" :key="index" @dblclick="DoubleClick(item)">
                    <div class="songcover"><img :src="item.music_image" alt=""></div>
                    <div class="songTlite"><span style="
                        color: var(--them-L-nav-color); font-weight: 500;">{{item.names}} 
                        <!-- <img style="margin-top: 3px;" class="span_huiyuan" src="../../assets/huiyuan (2).png" alt=""> -->
                        </span>
                    </div>
                    <div class="songName" style="color: var(--them-L-nav-color); font-weight: 500;">{{item.xingming}}</div>
                    <div class="songzhuanji" style="color: var(--them-L-nav-color); font-weight: 500;">{{item.zhuanji}}</div>
                    <div class="songTime" style="color: var(--them-L-nav-color); font-weight: 500">{{item.shijian}}</div>
                    <div class="songDian" @click="L_sanyuanbao(index)">•••</div>
                    <div class="Odang" :style="index>=5?{top:-170+'px'}:{top:15+'px'}" v-show="targetSpotone===index">
                        <!-- 内边距 -->
                        <div class="nei-bianju">
                            <div class="biao_img">
                                <img :src="item.music_image" alt="">
                                <div class="song-tc-text">
                                    <p>{{ item.names }}</p>
                                    <p>{{ item.xingming }}</p>
                                </div>
                            </div>
                            <div class="pop-bofang" @click="DoubleClick(item)">
                                <span class="icon iconfont icon-bofang"></span><p>播放</p>
                            </div>
                            <p style="border-top: solid 1px #e4e4e4; margin-top: 6px;margin-bottom: 6px;"></p>
                            <div class="pop-bofang" @click="$store.commit('changeSongId',item.id+1);">
                                <span class="icon iconfont icon-xiayishou" style="font-size: 20px;
                                  margin-left: 2px; margin-right: 2px;"></span><p>下一首</p>
                            </div>
                            <div class="pop-bofang" style="margin-top: 0;"  @click="DownloadSong(item)">
                                <span class="icon iconfont icon-xiazai"  style="font-size: 14px;
                                 margin-left: 5px;"></span>
                                 <img v-show="item.isnodown===1" style="position: absolute; bottom: 5px; width: 16px; left: 8px;" src="../../assets/xiaobiaoVIP.png" alt="">
                                 <p>下载</p>
                            </div>
                            <div class="pop-bofang" style="margin-top: 0;" @click="FenXiangSong()">
                                <img class="icon" v-show="$store.state.ashen=='true'" style="width: 16px; height: 16px; font-size: 14px; margin-left: 5px;" src="../../assets/fenxiangHei.png" alt="">
                                <img class="icon" v-show="$store.state.ashen=='false'" style="width: 16px; height: 16px; font-size: 14px; margin-left: 5px;" src="../../assets/fenxiangBai.png" alt="">
                                <p>分享</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="SetOff" v-show="songPop" @click="CloseAll()"></div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default{
        name:'Prevalent',
        data(){
            return{
                songPop:false,//控制 SetOff 弹窗的总 关闭！false 关闭 true 开启
                targetSpotone:-1,//当用户 点击左边 三个点的下标值
                targetSpotTwo:-1,//当用户 点击右边 三个点的小标值
                list:[],//数据
                ZhuTidata:[],
            }
        },
        mounted() {
            this.AjaxPreval();
        },
        methods:{
            //请求
            AjaxPreval(){
                axios.post('api/index/liuxing')
                .then(response => {
                    // 处理请求成功的响应
                    // console.log(response.data);
                    this.list = response.data.data;
                })
                .catch(error => {
                    // 处理请求失败的错误
                    console.error(error);
                });

                axios.post('api/index/liuxings')
                .then(response => {
                    // 处理请求成功的响应
                    // console.log(response.data);
                    this.ZhuTidata = response.data.data;
                })
                .catch(error => {
                    // 处理请求失败的错误
                    console.error(error);
                });
            },
            //关闭列表的小弹窗
            CloseAll(){
                console.log('关闭所有!');
                if(this.targetSpotone!==-1){
                    this.targetSpotone = -1;
                    this.songPop = false;
                }else{
                    this.songPop = true;
                }
            },
            //三个点 左边
            L_sanyuanbao(index){
                this.targetSpotone = index;
                this.songPop = true;
            },
            //双击播放
            DoubleClick(item){
                console.log('双击播放！',item.id)
                this.$store.commit('changeSongId',item.id);
            },
            //全部播放
            QuanSongPlay(){
                this.$store.commit('changeSongId',this.list[0].id);
            },
            //下载歌曲
            DownloadSong(item){
                console.log(item);
                if(this.$store.state.LoginStatus!==''){//判断用户是否登录 !==''是 ''不是
                    if(item.isnodown==1){//判断歌曲是否是会员 1是 0不是
                        if(this.$store.state.LoginStatus.isnovip==2){//判断用户是否是vip 2是 1不是
                            this.$store.commit('DownloadSongs',item);
                        }else{
                            this.$message.warning('你还不是vip用户，请充值成为vip用户！');
                        }
                    }else{
                        this.$store.commit('DownloadSongs',item);
                    }
                    
                }else{
                    this.$message.warning('请先登录');
                }
               
                
            },
            //分享
            FenXiangSong(){
                navigator.clipboard.writeText('https://www.mosichat.com/#/')
                .then(() => this.$message.success('歌曲链接已复制到剪贴板，快分享给朋友们吧'))
                .catch(()=> this.$message.error('歌曲链接复制失败，请手动复制'));
            }
        }
    }
</script>
<style lang="scss" scoped>
        .Prevalent_box {
            width: 100%;
            display: flex;
            justify-content: center;
            padding-bottom: 30px;
    
            .juzhong-box {
                width: 1366px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                align-items: center;
    
                .items-center {
                    width: 100%;
                    height: 200px;
                    display: flex;
                    margin-top: 20px;
                    align-items: center;
    
                    .TouXiang-img {
                        width: 200px;
                        height: 200px;
                        border-radius: 10px;
                        overflow: hidden;
    
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
    
                    .right-xinxi-text {
                        height: 125px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        margin-left: 20px;
    
                        .p-tlite-songName {
                            font-size: var(--nav-text-fsize28);
                            font-weight: bold;
                            font-family: YuanTi;
                            color: var(--them-color);
                        }
    
                        .p-introduce-Name {
                            font-size: var(--nav-songTlite-fsize);
                            color: var(--them-color);
                        }
    
                        .bk-tt {
                            width: 135px;
                            height: 33px;
                            border-radius: 30px;
                            background-color: rgb(23, 93, 255);
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
    
                            .p-pyle {
                                width: 130px;
                                display: flex;
                                align-items: center;
                                font-size: var(--nav-songTlite-fsize);
                                color: #fff;
                                justify-content: center;
                                cursor: pointer;
                                img {
                                    width: 12px;
                                    height: 12px;
                                    margin-right: 10px;
                                }
                            }
    
                            .jiahao {
                                border-left: solid 1px #a4a0a0;
                                height: 100%;
                                width: 37px;
                                color: #dfdfdf;
                                display: flex;
                                font-size: var(--buttom-song-tlite-size);
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                }
    
                .liebiao {
                    width: 100%;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    margin-top: 20px;
                    padding-bottom: 20px;
                    .tlite-show {
                        font-size: 20px;
                        font-family: YuanTi;
                        font-weight: bold;
                        // font-style: italic;
                        cursor: pointer;
                        color: var(--them-color);
                    }
    
                    .fu-tilte {
                        width: 100%;
                        height: 49px;
                        display: flex;
                        align-items: center;
                        border-radius: 5px;
                        margin-top: 6px;
                        p{
                            font-size: 15px;
                            span{
                                font-size: 15px;
                            }
                        }
                    }
    
                    .song-dan {
                        width: 100%;
                        height: 47px;
                        display: flex;
                        align-items: center;
                        border-radius: 8px;
                        transition: 0.2s;
                        margin-bottom: 5px;
                        position: relative;
    
                    }
    
                    .song-dan:hover {
                        transition: 0.2s;
                        cursor: pointer;
                        background-color: var(--them-L-nav-background);
                    }
                }
            }
        }
    
        .songcover {
            width: 33px;
            height: 33px;
            border-radius: 5px;
            // background-color: aqua;
            margin-left: 8px;
            margin-right: 8px;
            overflow: hidden;
    
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    
        .songTlite {
            width: 600px;
            height: 45px;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
    
            span:nth-child(1) {
                font-size: var(--nav-songTlite-fsize);
                font-weight: bold;
                font-family: YuanTi;
                color: var(--nav-song-color);
                display: flex;
                align-content: flex-end!important;
            }
    
            span:nth-child(2) {
                font-size: var(--nav-text-fsize12);
                color: var(--nav-song-name-color);
                font-weight: bold;
            }
        }
    
        .songName {
            width: 317px;
            height: 49px;
            line-height: 49px;
            font-size: var(--nav-songTlite-fsize);
            font-weight: bold;
            font-family: YuanTi;
            color: var(--nav-song-color);
        }
    
        .songzhuanji {
            width: 265px;
            height: 49px;
            margin-right: 15px;
            line-height: 49px;
            font-size: var(--nav-songTlite-fsize);
            font-weight: bold;
            font-family: YuanTi;
            color: var(--nav-song-color);
            overflow: hidden;
            /* 不让文本换行 除非遇到br标签 */
            white-space:nowrap;
            /* 溢出文字用...代替 */
            text-overflow: ellipsis;
        }
    
        .songTime {
            width: 60px;
            height: 49px;
            line-height: 49px;
            font-size: var(--nav-songTlite-fsize);
            font-weight: bold;
            font-family: YuanTi;
            color: var(--nav-song-color);
        }
    
        .songDian {
            width: 30px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                margin-right: 5px;
                font-size: 12px;
                color: var(--them-color);
                border-radius: 30px;
        }
    
        .Odang {
            position: absolute;
            right: 19px;
            width: 250px;
            height: 232px;
            border-radius: 15px;
            z-index: 100;
            background-color: var(--tc-background);
            border: solid 1px var(--border);
            backdrop-filter: blur(5px);
            top: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
    
            .nei-bianju {
                width: 230px;
                height: 215px;
                // background-color: aqua;
                border-radius: 10px;
    
                .biao_img {
                    width: 100%;
                    height: 55px;
                    border-bottom: solid 1px var(--border);
                    display: flex;
    
                    img {
                        width: 45px;
                        height: 45px;
                        border-radius: 8px;
                        object-fit: cover;
                    }
    
                    .song-tc-text {
                        margin-left: 7px;
                        //width: 100%;
                        height: 40px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
    
                        p:nth-child(1) {
                            font-size: 15px;
                            font-family: YuanTi;
                            color: var(--them-color);
                        }
    
                        p:nth-child(2) {
                            font-size: 12px;
                            font-family: YuanTi;
                            color:var(--fubiaoti);
                        }
                    }
                }
    
                .pop-bofang {
                    display: flex;
                    align-items: center;
                    margin-top: 5px;
                    height: 35px;
                    // border-bottom: solid 1px #e4e4e4;
                    border-radius: 5px;
                    position: relative;
                    .icon {
                        font-size: 13px;
                        margin-right: 6px;
                        margin-left: 5px;
                        color: var(--them-color);
                    }
    
                    p {
                        font-size: 13px;
                        font-family: YuanTi;
                        color: var(--them-color);
                    }
                }
    
                .pop-bofang:hover {
                    background-color: var(--hover-background);
                }
            }
        }
    
        .SetOff {
            width: 100vw;
            height: 100%;
            z-index: 99;
            position: absolute;
            top: 0;
        }
        .span_huiyuan{
            width: 15px;
            height: 15px;
            margin-left: 5px;
        }     
</style>